import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isBtnReady)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMyLocationClicked && _ctx.onMyLocationClicked(...args)))
      }, " Ir a mi ubicación "))
    : _createCommentVNode("", true)
}